import { RcFile, UploadFile } from 'antd/lib/upload';
import _ from 'lodash';
import imageCompression from 'browser-image-compression';

const DEFAULT_IMAGE_MIME = 'image/png';

export const getBase64 = (file: RcFile): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = error => reject(error);
  });

export const prepareFilesStatuses = (files: UploadFile[] | undefined) : UploadFile[] => {
  return _.map(files, (file => { return { ...file, status: 'done' }; }));
};

export const normalizeFile = (fileName: string, fileUrl?: string,) => {
  if (!fileUrl) return undefined;
  return [ { name: fileName, url: fileUrl, uid: fileUrl.split('/').pop(), status: 'done' } ];
};

export const compressImage = async (file: RcFile) => {
  const options = {
    useWebWorker: true,
    maxWidthOrHeight: 1920,
    initialQuality: 0.5
  };

  return await imageCompression(file, options);
};

const SANITIZE_FILENAME_REGEX = /[\\/:*?"<>|]+/g;

export const dataUrlToFile = (dataUrl: string, originalName: string, preferredName?: string) => {
  const [ , data ] = dataUrl.split(',');
  const binary = atob(data);
  const length = binary.length;
  const bytes = new Uint8Array(length);

  for (let i = 0; i < length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }

  const fallbackBase = originalName.replace(/\.[^.]+$/, '') || 'attachment';
  const trimmedPreferred = preferredName?.trim();
  const baseName = (trimmedPreferred && trimmedPreferred.replace(SANITIZE_FILENAME_REGEX, '_')) || fallbackBase;
  const fileName = `${baseName}.png`;

  return new File([ bytes ], fileName, { type: DEFAULT_IMAGE_MIME });
};